import { useState } from 'react';

/**
 * UsageInfo Component
 * @param {string} title - Panel başlığı (Örn: Nasıl Kullanılır?)
 * @param {string} description - Modül genel açıklaması
 * @param {Array} scenarios - Senaryo listesi [{ title, content }]
 * @param {string} color - Sayfanın ana rengi (emerald, rose, indigo, orange, cyan, etc.)
 */
export default function UsageInfo({ title = "Nasıl Kullanılır?", description, scenarios = [], color = "indigo" }) {
  const [isOpen, setIsOpen] = useState(false);

  const colors = {
    emerald: "from-emerald-500 to-teal-700 bg-emerald-50 border-emerald-100 text-emerald-700 shadow-emerald-50",
    rose: "from-rose-500 to-red-700 bg-rose-50 border-rose-100 text-rose-700 shadow-rose-50",
    indigo: "from-indigo-600 to-blue-700 bg-indigo-50 border-indigo-100 text-indigo-700 shadow-indigo-50",
    orange: "from-orange-500 to-amber-700 bg-orange-50 border-orange-100 text-orange-700 shadow-orange-50",
    amber: "from-amber-500 to-orange-700 bg-amber-50 border-amber-100 text-amber-700 shadow-amber-50",
    cyan: "from-cyan-500 to-sky-700 bg-cyan-50 border-cyan-100 text-cyan-700 shadow-cyan-50",
    blue: "from-blue-500 to-indigo-700 bg-blue-50 border-blue-100 text-blue-700 shadow-blue-50",
    violet: "from-violet-500 to-purple-700 bg-violet-50 border-violet-100 text-violet-700 shadow-violet-50",
    purple: "from-purple-500 to-fuchsia-700 bg-purple-50 border-purple-100 text-purple-700 shadow-purple-50",
    gray: "from-gray-600 to-gray-800 bg-gray-50 border-gray-100 text-gray-700 shadow-gray-50",
  };

  const theme = colors[color] || colors.indigo;

  return (
    <div className="mt-10 mb-6 group transition-opacity duration-300">
      <div className={`relative bg-white rounded-[2.5rem] border-2 ${theme.split(' ')[2]} shadow-xl ${theme.split(' ')[4]} p-1 overflow-hidden transition-shadow duration-500`}>
        {/* Toggle Header */}
        <button 
          onClick={() => setIsOpen(!isOpen)}
          className={`w-full flex items-center justify-between p-6 md:p-8 text-left transition-[background-color,transform] duration-300 hover:bg-gray-50/50 rounded-[2.2rem] group-hover:scale-[0.99] active:scale-[0.97]`}
        >
          <div className="flex items-center gap-6">
            <div className={`w-14 h-14 bg-gradient-to-br ${theme.split(' ')[0]} ${theme.split(' ')[1]} rounded-2xl flex items-center justify-center text-white text-2xl shadow-xl shadow-gray-200 transition-transform duration-500 ${isOpen ? 'rotate-[360deg]' : ''}`}>
              💡
            </div>
            <div>
              <h3 className="text-xl font-black text-gray-900 tracking-tighter uppercase">{title}</h3>
              {!isOpen && description && <p className="text-[10px] font-black text-gray-400 uppercase tracking-[0.2em] mt-1 line-clamp-1">{description}</p>}
            </div>
          </div>
          <div className={`w-12 h-12 bg-gray-50 rounded-xl flex items-center justify-center text-xl transition-[transform,background-color] duration-500 ${isOpen ? 'rotate-180 bg-gray-100 shadow-inner' : 'hover:bg-gray-100 shadow-sm'}`}>
            ⌄
          </div>
        </button>

        {/* Content Area */}
        <div className={`transition-[max-height,opacity] duration-500 ease-in-out overflow-hidden ${isOpen ? 'max-h-[2000px] opacity-100' : 'max-h-0 opacity-0'}`}>
          <div className="px-8 pb-10 pt-4 space-y-8">
            <div className="border-t border-gray-100 pt-8">
               <p className="text-sm font-bold text-gray-600 leading-relaxed max-w-3xl border-l-4 border-gray-100 pl-6 italic">
                 {description}
               </p>
            </div>

            {scenarios.length > 0 && (
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {scenarios.map((s, i) => (
                  <div key={i} className="bg-gray-50/50 rounded-3xl p-6 border border-gray-100 hover:bg-white hover:shadow-2xl hover:shadow-gray-100 transition-[background-color,box-shadow,transform] duration-300 group/card">
                     <div className="flex items-center gap-4 mb-4">
                        <span className={`w-3 h-3 rounded-full bg-gradient-to-br ${theme.split(' ')[0]} ${theme.split(' ')[1]} shadow-lg animate-pulse`}></span>
                        <h4 className="text-xs font-black text-gray-800 uppercase tracking-widest">{s.title}</h4>
                     </div>
                     <p className="text-[11px] font-bold text-gray-500 leading-6 uppercase tracking-tight">
                        {s.content}
                     </p>
                  </div>
                ))}
              </div>
            )}

            <div className={`p-6 rounded-[1.8rem] bg-gradient-to-r ${theme.split(' ')[0]} ${theme.split(' ')[1]} text-white/90 shadow-2xl ${theme.split(' ')[4]}`}>
               <div className="flex items-center gap-4 mb-3">
                  <span className="text-2xl">✨</span>
                  <p className="text-[10px] font-black uppercase tracking-[0.2em]">Sistem İpucu</p>
               </div>
               <p className="text-xs font-black tracking-tight leading-relaxed">
                 BU MODÜLDE YAPILAN TÜM DEĞIŞIKLIKLER SISTEM GENELINDE ANLIK OLARAK GÜNCELLENIR VE TÜM DEPARTMANLARDA GEÇERLI OLUR.
               </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
